// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"92bcfeff","367":"fcd86e44"}[chunkId] + ".chunk.js";
};